import { useQuery } from "@tanstack/react-query";
import { Link, useNavigate, useSearch } from "@tanstack/react-router";
import { api } from "../lib/api.ts";
import { useT } from "../lib/i18n.ts";
import { goBackTo } from "../lib/nav.ts";
import { Ic } from "../components/Icons.tsx";

/** Places list (round 4): indoor/outdoor, map spot, what they offer. Editing happens on /settings/places/<id>. */
export function Places() {
  const t = useT();
  const nav = useNavigate();
  const search = useSearch({ strict: false }) as { back?: string };
  const { data } = useQuery({ queryKey: ["places"], queryFn: api.places.list });
  const { data: needsData } = useQuery({ queryKey: ["needs"], queryFn: api.needs.list });
  const needName = (id: string) => needsData?.needs.find((n) => n.id === id)?.name ?? "";
  const goBack = () => void goBackTo(nav, search.back, "/settings/shelf");

  return (
    <div>
      <div className="screen-head">
        <button className="icon-btn" aria-label={t("back")} onClick={goBack}>{Ic.back()}</button>
        <h1 className="title">{t("places.title")}</h1>
        <Link className="btn btn-primary" style={{ minHeight: 36 }} to="/settings/places/$id" params={{ id: "new" }}>{Ic.plus({ size: 14 })} {t("places.new")}</Link>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "var(--sp-2)" }}>
        {(data?.places ?? []).map((p) => (
          <Link key={p.id} className="card" to="/settings/places/$id" params={{ id: p.id }} style={{ padding: "var(--sp-3)", color: "inherit", textDecoration: "none" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "var(--sp-2)" }}>
              <strong style={{ flex: 1 }}>{p.name}</strong>
              <span className="chip chip-on" style={{ pointerEvents: "none" }}>{t(p.kind === "indoor" ? "places.indoor" : "places.outdoor")}</span>
              <span style={{ color: "var(--ink-3)", display: "inline-flex" }}>{Ic.chevron({ size: 16 })}</span>
            </div>
            {p.lat != null && <div className="micro" style={{ marginTop: 4, display: "flex", alignItems: "center", gap: 4 }}>{Ic.place({ size: 12 })} {p.radiusM ?? 150} m</div>}
            {p.needIds.length > 0 && (
              <div className="chip-row" style={{ marginTop: "var(--sp-2)" }}>
                {p.needIds.map(needName).filter(Boolean).map((n) => <span key={n} className="chip chip-on" style={{ pointerEvents: "none", minHeight: 26 }}>{n}</span>)}
              </div>
            )}
          </Link>
        ))}
      </div>
    </div>
  );
}

